export default __webpack_public_path__ + "images/4ba3f175462e50a8ab29eece1b8d560e.svg";